// eslint-disable-next-line no-unused-vars
import React from "react";
import Utils from "../utils/utils";


class LanguageService extends Utils.EventEmitter {
  // Function to get language profile
   // Function to get language profile
   GetLanguageProfile(language_id = "", name = "", code = "", status = "active", apiKey) {
    return new Promise((resolve, reject) => {
      const url = `${window.env.REACT_APP_API_IP}/ns-core/config/language/get`;
      const body = JSON.stringify({
        "get": {
          "language_id": language_id,
          "name": name,
          "code": code,
          "status": status
        }
      });
      const headers = {
        "Content-Type": 'application/json',
        "apiKey": apiKey,
        "apiSession": localStorage.getItem("auth_token"),
      };
      fetch(url, {
        method: "POST",
        headers,
        body
      })
        .then((response) => response.json())
        .then((json) => resolve(json))
        .catch((err) => {
          if (process.env.NODE_ENV === "development") console.log("err ", err);
          reject(err.response ? err.response.data.error_description : err);
        });
    });
  }

  // Function to set language profile
  SetLanguageProfile(language_id = "", name = "", code = "", status = "active", apiKey) {
    return new Promise((resolve, reject) => {
      const url = `${window.env.REACT_APP_API_IP}/ns-core/config/language/post`;
      const body = JSON.stringify({
        "post": [{
          "language_id": language_id,
          "name": name,
          "code": code,
          "status": status
        }]
      });
      const headers = {
        "Content-Type": 'application/json',
        "apiKey": apiKey,
        "apiSession": localStorage.getItem("auth_token"),
      };
      fetch(url, {
        method: "POST",
        headers,
        body
      })
        .then((response) => response.json())
        .then((json) => resolve(json))
        .catch((err) => {
          if (process.env.NODE_ENV === "development") console.log("err ", err);
          reject(err.response ? err.response.data.error_description : err);
        });
    });
  }

  // Function to get language dictionary translations
  GetLanguageDictionaryTranslations(language_id = "", name = "", code = "", compact = false, variable_name = false, status = "active", apiKey) {
    return new Promise((resolve, reject) => {
      const url = `${window.env.REACT_APP_API_IP}/ns-core/config/language/dictionary/translations/get`;
      const body = JSON.stringify({
        "get": {
          "language_id": language_id,
          "name": name,
          "code": code,
          "compact": compact,
          "variable_name": variable_name,
          "status": status
        }
      });
      const headers = {
        "Content-Type": 'application/json',
        "apiKey": apiKey,
        "apiSession": localStorage.getItem("auth_token"),
      };
      fetch(url, {
        method: "POST",
        headers,
        body
      })
        .then((response) => response.json())
        .then((json) => resolve(json))
        .catch((err) => {
          if (process.env.NODE_ENV === "development") console.log("err ", err);
          reject(err.response ? err.response.data.error_description : err);
        });
    });
  }

  // Function to get language dictionary
  GetLanguageDictionary(language_dictionary_id = "", status = "active", apiKey) {
    return new Promise((resolve, reject) => {
      const url = `${window.env.REACT_APP_API_IP}/ns-core/config/language/dictionary/get`;
      const body = JSON.stringify({
        "get": {
          "language_dictionary_id": language_dictionary_id,
          "status": status
        }
      });
      const headers = {
        "Content-Type": 'application/json',
        "apiKey": apiKey,
        "apiSession": localStorage.getItem("auth_token"),
      };
      fetch(url, {
        method: "POST",
        headers,
        body
      })
        .then((response) => response.json())
        .then((json) => resolve(json))
        .catch((err) => {
          if (process.env.NODE_ENV === "development") console.log("err ", err);
          reject(err.response ? err.response.data.error_description : err);
        });
    });
  }

  // Function to set language dictionary
  SetLanguageDictionary(language_dictionary_id = "", variable_name = "", sensitive = "true", translation = [{ "code": "", "value": "" }], status = "active", apiKey) {
    return new Promise((resolve, reject) => {
      const url = `${window.env.REACT_APP_API_IP}/ns-core/config/language/dictionary/post`;
      const body = JSON.stringify({
        "post": [{
          "language_dictionary_id": language_dictionary_id,
          "status": status,
          "variable_name": variable_name,
          "sensitive": sensitive,
          "translation": translation
        }]
      });
      const headers = {
        "Content-Type": 'application/json',
        "apiKey": apiKey,
        "apiSession": localStorage.getItem("auth_token"),
      };
      fetch(url, {
        method: "POST",
        headers,
        body
      })
        .then((response) => response.json())
        .then((json) => resolve(json))
        .catch((err) => {
          if (process.env.NODE_ENV === "development") console.log("err ", err);
          reject(err.response ? err.response.data.error_description : err);
        });
    });
  }
}

const instance = new LanguageService();

export default instance;
